// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/style.less
// module id = XL/+
// module chunks = 11